var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import AnimationContent from './private/utils/buttonAnimations/AnimationContent';
import ButtonComponent from './styles/ButtonComponent';
import Hover from './styles/Hover';
import IconLeft from './styles/IconLeft';
import IconRight from './styles/IconRight';
const Button = (_a) => {
    var { children, variant = 'fill', size = 'md', icon, // deprecated
    iconLeft, // not boolean anymore
    iconRight, // not boolean anymore
    iconOnly, // deprecated
    fullWidth, disabled, animation, as, className } = _a, rest = __rest(_a, ["children", "variant", "size", "icon", "iconLeft", "iconRight", "iconOnly", "fullWidth", "disabled", "animation", "as", "className"]);
    const [isHover, setIsHover] = useState(false);
    const hasAnimationContent = animation === 'progress' || animation === 'success';
    return (React.createElement(ButtonComponent, Object.assign({ size: size, variant: variant, icon: icon, iconLeft: iconLeft, iconRight: iconRight, iconOnly: iconOnly, fullWidth: fullWidth, disabled: disabled, animation: animation, as: as, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), customClassName: className }, rest),
        hasAnimationContent ? (React.createElement(AnimationContent, { iconLeft: iconLeft, children: children, iconRight: iconRight, iconOnly: iconOnly, animation: animation, size: size, fullWidth: fullWidth, variant: variant })) : (React.createElement(React.Fragment, null,
            iconLeft && (React.createElement(IconLeft, { fullWidth: fullWidth, iconLeft: iconLeft, size: size })),
            children,
            iconRight && (React.createElement(IconRight, { fullWidth: fullWidth, iconRight: iconRight, size: size })),
            iconOnly)),
        React.createElement(Hover, { isHover: isHover, variant: variant })));
};
export default Button;
